import React from "react";

function Resume() {
  // Get the base URL from the homepage in package.json or fall back to empty string
  const baseUrl = process.env.PUBLIC_URL || '';
  
  return (
    <div style={{ 
      textAlign: "center", 
      padding: "50px",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}>
      <h1 style={{ marginBottom: "30px" }}>Resume</h1>
      <div style={{ marginBottom: "30px" }}>
        <a 
          href={`${baseUrl}/Resume.pdf`}
          download="HarsshaVardhan_Resume.pdf"
          style={{
            padding: "12px 24px",
            backgroundColor: "#007bff",
            color: "white",
            textDecoration: "none",
            borderRadius: "5px",
            fontSize: "16px",
            fontWeight: "500",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            transition: "all 0.3s ease"
          }}
        >
          Download Resume
        </a>
      </div>
      <div style={{ width: "100%", maxWidth: "900px", height: "800px" }}>
        <iframe 
          src={`${baseUrl}/Resume.pdf`}
          width="100%" 
          height="100%"
          style={{ 
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
          }}
          title="Resume"
        ></iframe>
      </div>
    </div>
  );
}

export default Resume;